export default "__VITE_ASSET__IJRyAvm4BZECTcyS$rar3A__"